import { render, staticRenderFns } from "./ScoutRecommendedMembers.vue?vue&type=template&id=48667de0"
import script from "./ScoutRecommendedMembers.vue?vue&type=script&lang=js"
export * from "./ScoutRecommendedMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports